<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <div v-for="(itemTitle, i) in items" :key="i" :class="['title-description', schema.attributes.textCenter && 'text-center']">
      <h2 v-if="schema.attributesTitle.visible" v-bind="schema.attributesTitle">{{ itemTitle.title }}</h2>
      <h3 v-if="schema.attributesSubTitle.visible" v-bind="schema.attributesSubTitle">{{ itemTitle.sub_title }}</h3>
      <p v-if="schema.attributesDescription.visible" v-bind="schema.attributesDescription">{{ itemTitle.description }}</p>
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  data() {
    return {
      items: []
    };
  },

  created() {
    this.items = this.schema.attributes.items;
  },

  watch: {
    schema: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.items = this.schema.attributes.items;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.title-description {
  &.text-center {
    h2,
    h3,
    p {
      text-align: center;
    }
  }
  h2 {
    margin: 0 0 10px 0;
  }

  h3 {
    margin: 0 0 5px 0;
  }

  p {
    font-weight: normal;
  }
}
</style>
